import { Controller } from "@hotwired/stimulus"
import { createCIHotspotViewer } from "../lib/hotspot_pseudo_fullscreen"

export default class extends Controller {
  static targets = ["mount", "frontButton", "backButton"]
  static values = {
    frontSrc: String,
    backSrc: String,
    frontHotspots: { type: String, default: "[]" },
    backHotspots: { type: String, default: "[]" },
    name: { type: String, default: "Device" },
    side: { type: String, default: "front" }
  }

  connect() {
    this.viewer = null
    this.pseudoFullscreenCleanup = null
    this.renderScene(this.sideValue)
  }

  disconnect() {
    this.destroyViewer()
  }

  showFront(event) {
    event?.preventDefault()
    this.renderScene("front")
  }

  showBack(event) {
    event?.preventDefault()
    this.renderScene("back")
  }

  renderScene(side) {
    const normalizedSide = side === "back" ? "back" : "front"
    const src = normalizedSide === "back" ? this.backSrcValue : this.frontSrcValue
    if (!src || !this.hasMountTarget) return

    this.sideValue = normalizedSide
    this.destroyViewer()

    const hotspots =
      normalizedSide === "back"
        ? this.parseHotspots(this.backHotspotsValue)
        : this.parseHotspots(this.frontHotspotsValue)

    const { viewer, cleanupPseudoFullscreen } = createCIHotspotViewer(this.mountTarget, {
      src,
      alt: `${this.nameValue} ${normalizedSide} image`,
      zoom: true,
      trigger: "click",
      hotspots
    })

    this.viewer = viewer
    this.pseudoFullscreenCleanup = cleanupPseudoFullscreen

    this.updateToggleButtons()
  }

  updateToggleButtons() {
    if (this.hasFrontButtonTarget) {
      this.frontButtonTarget.classList.toggle("btn-primary", this.sideValue === "front")
      this.frontButtonTarget.classList.toggle("btn-outline", this.sideValue !== "front")
    }

    if (this.hasBackButtonTarget) {
      this.backButtonTarget.classList.toggle("btn-primary", this.sideValue === "back")
      this.backButtonTarget.classList.toggle("btn-outline", this.sideValue !== "back")
    }
  }

  destroyViewer() {
    if (this.pseudoFullscreenCleanup) {
      this.pseudoFullscreenCleanup()
      this.pseudoFullscreenCleanup = null
    }

    if (this.viewer) {
      this.viewer.destroy()
      this.viewer = null
    }
  }

  parseHotspots(raw) {
    try {
      const parsed = typeof raw === "string" ? JSON.parse(raw) : raw
      return Array.isArray(parsed) ? parsed : []
    } catch {
      return []
    }
  }
}
